import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn — merge classnames + dédoublonne les classes Tailwind conflictuelles.
 * @example
 *   cn('px-2', condition && 'bg-ink', userClass)
 *   cn('p-2', 'p-4') → 'p-4'  // tailwind-merge garde la dernière
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
